import axios from "axios";

export default function OfferShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/offer/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
